import axios from "axios";
import { adnPageSize } from "../components/common/GeneralConfigurations";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const organizationStaffApiUrl = `${baseApiUrl}/api/OrganizationStaff`;

export async function getStaff(
  pageNumber = 1,
  pageSize = adnPageSize,
  orderBy = "",
  searchName = "",
  searchHasPhone = null,
  searchDeleted = false
) {
  return await httpRequest(
    fetchStaff.bind(
      this,
      pageNumber,
      pageSize,
      orderBy,
      searchName,
      searchHasPhone,
      searchDeleted
    )
  );
}

async function fetchStaff(
  pageNumber,
  pageSize,
  orderBy,
  searchName,
  searchHasPhone,
  searchDeleted
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${organizationStaffApiUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}
  &orderBy=${orderBy}&name=${searchName}&hasPhone=${searchHasPhone}&deleted=${searchDeleted}`,
    config
  );
}

export async function getStaffById(id) {
  return await httpRequest(fetchStaffById.bind(this, id));
}

async function fetchStaffById(id) {
  let config = getHttpHeaders();
  return await axios.get(`${organizationStaffApiUrl}/${id}`, config);
}

export async function addStaff(newStaff) {
  return await httpRequest(postStaff.bind(this, newStaff));
}

async function postStaff(newStaff) {
  let config = getHttpHeaders();
  return await axios.post(`${organizationStaffApiUrl}`, newStaff, config);
}

export async function updateStaff(id, updatedStaff) {
  return await httpRequest(putStaff.bind(this, id, updatedStaff));
}

async function putStaff(id, updatedStaff) {
  let config = getHttpHeaders();
  return await axios.put(
    `${organizationStaffApiUrl}`,
    { ...updatedStaff, id },
    config
  );
}

export async function deleteStaff(id) {
  return await httpRequest(deleteStaffRequest.bind(this, id));
}

async function deleteStaffRequest(id) {
  let config = getHttpHeaders();
  return await axios.delete(`${organizationStaffApiUrl}/${id}`, config);
}
